<template>
  <w-sliding-popup ref="slidingPopup" :title="title" top="50px" :width="width" :appendToBody="true" @close="close">
    <div slot="content">
      <el-table-wrapper v-loading="isLoading" ref="table" border header-align="center" :data="tableData" :columns="tableColumns"
      :show-custom-header="false" :pagination="false">
        <template slot-scope="scope" slot="slot">
          <div v-if="rscId === 'CPU_USERATE'">
            <span v-if="scope.row.value === null">{{ EMPTY_TEXT }}</span>
            <el-progress v-else :text-inside="true" :stroke-width="14" :percentage="scope.row.value" :color="getEventBgColor(scope.row.eventlevelId)" />
          </div>
          <span v-else-if="rscId === 'DEVICE_TEMP' || rscId === 'MODULE_TEMP'"> {{ convertCValue(scope.row.value) }}</span>
          <span v-else-if="rscId === 'MODULE_STATUS'"> {{ getTableValueAfterCheckEmpty(null, null, scope.row.value) }} </span>
          <span v-else-if=" rscId === 'FAN_STATUS' || rscId === 'POWER_STATUS'"> {{ getTableValueAfterCheckEmpty(null, null, scope.row.value) }} </span>
        </template>
      </el-table-wrapper>
    </div>
  </w-sliding-popup>
</template>

<script>
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import RscAPI from '@/api/model/rsc';
import PerformanceAPI from '@/api/performance/common';
import { convertValuByUnit } from '@/utils/number';
import { isNil } from 'lodash';
import { isTrue } from '@/utils/boolean';

export default {
  name: 'WMultipleRscKeyInfoPopup',
  props: {
    configOidStatusList: {
      type: Object,
      defulat: () => {},
    },
  },
  data() {
    return {
      rscList: [],
      objId: null,
      objName: null,
      rscId: null,
      isLoading: false,
      tableData: [],
      tableColumns: [],
      params: {
        managetypeId: 'NMS',
        rsctypeId: 'DEVICE_PERF',
      },
      EMPTY_TEXT,
      objCompanyId: null,
      width: '400px',
      resultValueInfo: {
        CPU_USERATE: 'CPU 사용률',
        DEVICE_TEMP: '장비 온도',
        MODULE_STATUS: '모듈 상태',
        MODULE_TEMP: '모듈 온도',
        FAN_STATUS: '팬 상태',
        POWER_STATUS: '파워 상태',
      },
    };
  },
  computed: {
    title() {
      if (!isNil(this.objName) && !isNil(this.rscId)) {
        const objName = this.objName;
        const rscName = this.rscList.filter((item) => item.rscId === this.rscId)[0].rscName;
        return `${objName} - ${rscName}`;
      }
      return null;
    },
    eventInfo() {
      const eventInfo = this.$store.getters.eventlevelInfo;
      return eventInfo;
    },
  },
  created() {
    RscAPI.getRscList(this.params).then((response) => {
      const result = response.data;
      if (result.success) {
        this.rscList = result.data;
      }
    });
  },
  methods: {
    open(objId, objName, rscId, objCompanyId) {
      if (rscId === 'MODULE_STATUS' || rscId === 'MODULE_TEMP' || rscId === 'FAN_STATUS' || rscId === 'POWER_STATUS') {
        this.width = '600px';
      }
      this.objId = objId;
      this.objName = objName;
      this.rscId = rscId;
      this.tableColumns = this.getTableColumns();
      this.$refs.slidingPopup.visible = true;
      this.objCompanyId = objCompanyId;
      this.loadData();
    },
    close() {
      this.tableData = [];
      this.objId = null;
      this.objName = null;
      this.rscId = null;
    },
    loadData() {
      const params = {
        objId: this.objId,
        rscId: this.rscId,
      };
      this.isLoading = true;
      PerformanceAPI.getMultipleRscKeyPerfList(Object.assign(params, this.params)).then((response) => {
        const result = response.data;
        if (result.success) {
          const resultData = result.data;
          if (this.rscId === 'MODULE_STATUS') {
            this.tableData = resultData.filter((item) => item.rscKey !== '_');
          } else {
            this.tableData = result.data;
          }
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },
    convertCValue(value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, '℃', false);
    },
    convertValue(value) {
      return isNil(value) ? EMPTY_TEXT : value;
    },
    getEventBgColor(eventlevelId) {
      if (!isNil(eventlevelId)) {
        return this.eventInfo[eventlevelId].eventlevelColorBg;
      }
      return '';
    },
    getTableColumns() {
      if (this.rscId === 'MODULE_STATUS' || this.rscId === 'MODULE_TEMP' || this.rscId === 'FAN_STATUS' || this.rscId === 'POWER_STATUS') {
        return [
          {
            prop: 'rscKeyName',
            label: '자원 키',
            width: 100,
            searchable: true,
            sortable: true,
          },
          {
            prop: 'moduleName',
            label: '모듈 이름',
            searchable: true,
            sortable: true,
            formatter: this.getTableValueAfterCheckEmpty,
          },
          {
            prop: 'value',
            label: this.resultValueInfo[this.rscId],
            searchable: true,
            sortable: true,
            scopedSlot: 'slot',
          },
        ];
      }
      return [
        {
          prop: 'rscKeyName',
          label: '자원 키',
          width: 100,
          searchable: true,
          sortable: true,
        },
        {
          prop: 'value',
          label: this.resultValueInfo[this.rscId],
          searchable: true,
          sortable: true,
          scopedSlot: 'slot',
        },
      ];
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    convertStatusBoolean(data) {
      if (EMPTY_TEXT !== data) {
        return isTrue(data) ? 'UP' : 'DOWN';
      }
      return data;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/group/perfinfo/popup/MultipleRscKeyInfoPopup.vue